import styled from "styled-components";
import { ClientSettingsSectionIconDefaultBox } from "./client-settings-section-icon.default.box";
import { grayColors } from "../../../../../../themes/architecture/gray-colors";

export const ClientSettingsSectionIconMrGreenBox = styled(ClientSettingsSectionIconDefaultBox)`
    color: ${grayColors.gray153};
`